export default __webpack_public_path__ + "static/media/Eco-Friendly.504306cb.svg";